import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import { statuses } from "./dynamicsConstants";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/reducers/knowledgeReducer";
import axios from "../../plugins/axios";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    IconButton
} from "@material-ui/core";
import {
    Delete as DeleteIcon
} from "@material-ui/icons";


const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

const KnowledgeDocumentsTable = ({ documentIds, knowledgeState, allColumns, getInitialData, onRowClick, withoutArticleIds, onDelete }) => {
    const [page, setPage] = useState(0);

    const { categories, documents } = knowledgeState;
    const rowsPerPage = 10;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {

        if (categories.length === 0)
            getInitialData();
    }, []);

    const visibleDocuments = useMemo(() => {
        var list = documents;
        if (documentIds)
            list = documents.filter(d => documentIds.includes(d.id));

        console.log(documentIds, list)
        return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    }, [documents, page, documentIds]);

    const documentCount = useMemo(() => { return documentIds ? documentIds.length : documents.length }, [documents, documentIds]);

    const documentSelected = (doc) => {
        if (onRowClick)
            onRowClick(doc.id)
        else
            downloadDocument(doc);
    };

    const downloadDocument = async (doc) => {
        var response = await axios.get(
            `${apiUrl}/document/retrieve/${doc.identifier}`,
            { responseType: "arraybuffer" }
        );
        console.log(response);
        let blob = new Blob([response.data], { type: doc.contentType });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = doc.filename;
        link.click();
    };

    return (
        <React.Fragment>
            <Table size="small" style={{tableLayout:'fixed', width: '100%'}}>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell style={{width:'20%'}}>Created On</TableCell>
                        {allColumns && <TableCell>Status</TableCell>}
                        {onDelete && <TableCell></TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        visibleDocuments.map((d) => (
                            <TableRow key={d.id} onClick={() => { documentSelected(d) }} style={{ cursor: 'pointer' }}>
                                <TableCell style={{  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{d.name}</TableCell>
                                <TableCell>{format(new Date(d.createdOn), "dd/MM/yyyy HH:mm")}</TableCell>
                                {allColumns && <TableCell>{statuses[d.articleStatus]}</TableCell>}
                                {onDelete && <TableCell><IconButton onClick={(e) => { e.stopPropagation(); onDelete(d.id); }}><DeleteIcon /></IconButton></TableCell>}
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={documentCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
            />
        </React.Fragment>
    );
};


const mapStateToProps = (state) => ({
    knowledgeState: state.knowledgeReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeDocumentsTable);
